import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CardsApiAxiosParamCreator } from '../../../apis/cards-api';
import { BaseApi } from '@/service/BaseApi';

export class CardsApi extends BaseApi {

  /**
   * 
   * @summary Delete card by id
   * @param {number} id Card id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public static async deleteById(id: number, options?: AxiosRequestConfig): Promise<AxiosResponse<any>>{ //v2 api 
    const axiosArgs = await CardsApiAxiosParamCreator().deleteCards(id, options);
    
    return this.getAuthorizedAxios().request({
      url: axiosArgs.url,
      method: axiosArgs.options.method,
      headers: axiosArgs.options.headers,
      params: axiosArgs.options.params,
      data: axiosArgs.options.data,
    });
  }
}
